query competitionsBySport(
  $startDate: Datetime
  $sportId: UUID
) {
  competitions: allCompetitionsHavingEventsBetween(
    startdate: $startDate
    sportid: $sportId
  ) {
    nodes {
      competitionId
      competitionName
    }
  }
}
